// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9089e8a","239":"b44b1047","455":"248afb6d"}[chunkId] + ".chunk.js";
};